import React, { useState, useEffect } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
import axios from 'axios'; // Import Axios
import logo from "../../../assets/img/logo.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import AdminSidebar from '../Adminsidebar/AdminSidebar';

function Tester() {
    const [activeLink, setActiveLink] = useState(null);

    const handleLinkClick = (link) => {
        setActiveLink(link);
    };
    const [specialities, setSpecialities] = useState([]);
    const [newSpecialityFile, setNewSpecialityFile] = useState(null);
    const [newSpecialityHeading, setNewSpecialityHeading] = useState('');
    const [editSpecialityFile, setEditSpecialityFile] = useState(null);
    const [editSpecialityHeading, setEditSpecialityHeading] = useState('');
    const [message, setMessage] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSpecialityId, setDeleteSpecialityId] = useState(null);
    const [editSpecialityId, setEditSpecialityId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };


    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 


    useEffect(() => {
        fetchSpecialities();

        // Initialize DataTables after component mounts
        if (window.$) {
            setTimeout(() => { // Add a small delay
                window.$('.datatable').DataTable();
            }, 500);
        }
    }, []);

    // Function to fetch specialities from the backend
    const fetchSpecialities = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/specialities-images`); // Adjust the endpoint as needed
            setSpecialities(response.data);
        } catch (err) {
            setError(err);
            setMessage('Error fetching speciality: ' + err.message)
            console.error("Error fetching speciality:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddSpeciality = () => {
        setShowAddModal(true);
    };

    const handleEditSpeciality = (speciality) => {
        setEditSpecialityId(speciality._id); // Use _id, assuming that's your MongoDB ID
        setEditSpecialityHeading(speciality.heading);
        setShowEditModal(true);
        setEditSpecialityFile(null); // Reset the file input
    };

    const handleDeleteSpeciality = (specialityId) => {
        setDeleteSpecialityId(specialityId);
        setShowDeleteModal(true);
    };

    const handleCloseModal = () => {
        setShowAddModal(false);
        setShowEditModal(false);
        setShowDeleteModal(false);
        setNewSpecialityFile(null);
        setNewSpecialityHeading('');
        setEditSpecialityFile(null);
        setEditSpecialityHeading('');
        setDeleteSpecialityId(null);
        setEditSpecialityId(null);

    };

    const handleNewSpecialityFileChange = (e) => {
        setNewSpecialityFile(e.target.files[0]);
    };

    const handleEditSpecialityFileChange = (e) => {
        setEditSpecialityFile(e.target.files[0]);
    };

    const handleAddSpecialitySubmit = async (e) => {
        e.preventDefault();

        if (!newSpecialityFile || !newSpecialityHeading) {
            setMessage('Please fill all fields and select an image.');
            return;
        }

        const formData = new FormData();
        formData.append('image', newSpecialityFile);
        formData.append('heading', newSpecialityHeading);

        try {
            const response = await axios.post(`${API_BASE_URL}/upload-specialities`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setMessage(response.data.message);
            setNewSpecialityFile(null);
            setNewSpecialityHeading('');
            fetchSpecialities();
            handleCloseModal();
        } catch (err) {
            console.error("Error adding speciality:", err);
            setMessage('Error adding speciality: ' + err.message);
        }
    };

    const handleEditSpecialitySubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        if (editSpecialityFile) {
            formData.append('image', editSpecialityFile);
        }
        formData.append('heading', editSpecialityHeading); // Add heading even if no file

        try {
            const response = await axios.put(`${API_BASE_URL}/specialities/${editSpecialityId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setMessage(response.data.message);
            setEditSpecialityFile(null);
            setEditSpecialityHeading('');
            fetchSpecialities();
            handleCloseModal();
        } catch (err) {
            console.error("Error editing speciality:", err);
            setMessage('Error editing speciality: ' + err.message);
        }
    };

    const confirmDelete = async () => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/specialities/${deleteSpecialityId}`);
            setMessage(response.data.message);
            fetchSpecialities();
            handleCloseModal();
        } catch (err) {
            console.error("Error deleting speciality:", err);
            setMessage('Error deleting speciality: ' + err.message);
        }
    };
    // Search functionality
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    // Filter images based on search term (example: filtering by heading)
    const filteredSpecialities = specialities.filter(speciality =>
        speciality.heading.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page when changing images per page
    };
    // Calculate indexes for current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // Slice images for current page
    const currentSpecialities = filteredSpecialities.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredSpecialities.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }
    const paginate = pageNumber => setCurrentPage(pageNumber);


    if (loading) {
        return <div>Loading specialities...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }


    return (

        <div className="main-wrapper">
           
<AdminSidebar/>
          
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-7 col-auto">
                                <h3 className="page-title">Specialities</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Dashboard</a></li>
                                    <li className="breadcrumb-item active">Specialities</li>
                                </ul>
                            </div>
                            <div className="col-sm-5 col">
                                <button onClick={handleAddSpeciality} className="btn btn-primary float-right mt-2">Add</button>
                            </div>
                             {/* Search Input */}
                        </div>
                    </div>
                    {message && <div className="alert alert-info">{message}</div>}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Specialities..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                              <div>
                             <label>Items per page:</label>
                                 <select
                                     className="form-control"
                                     onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                     >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>

                                  </select>
                             </div>
                            <nav aria-label="Specialities pagination">
                                <ul className="pagination justify-content-center">
                                    {pageNumbers.map(number => (
                                        <li key={number} className="page-item">
                                            <button onClick={() => paginate(number)} className="page-link">
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                            </div>
                                    <div className="table-responsive">
                                        <table className="datatable table table-hover table-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Specialities</th>
                                                    <th>Heading</th>
                                                    <th className="text-right">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentSpecialities.map((speciality, index) => (
                                                    <tr key={speciality._id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <h2 className="table-avatar">
                                                                <a href="profile.html" className="avatar avatar-sm mr-2">
                                                                    <img className="avatar-img" src={`${API_BASE_URL}${speciality.path}`} alt="Speciality" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                                                </a>
                                                            </h2>
                                                        </td>
                                                        <td>{speciality.heading}</td>
                                                        <td className="text-right">
                                                            <div className="actions">
                                                                <button
                                                                    onClick={() => handleEditSpeciality(speciality)}
                                                                    className="btn btn-sm bg-success-light"
                                                                >
                                                                    <i className="fe fe-pencil"></i> Edit
                                                                </button>
                                                                <button
                                                                    onClick={() => handleDeleteSpeciality(speciality._id)} // Use _id for delete
                                                                    className="btn btn-sm bg-danger-light"
                                                                >
                                                                    <i className="fe fe-trash"></i> Delete
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                </div>
            </div>
            {/*Add Modal */}
            {showAddModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add speciality</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><FontAwesomeIcon icon={faTimes} /></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleAddSpecialitySubmit}>
                                    <div className="row form-row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Heading</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={newSpecialityHeading}
                                                    onChange={(e) => setNewSpecialityHeading(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Image</label>
                                                <input type="file" className="form-control" onChange={handleNewSpecialityFileChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-primary btn-block">Save Changes</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/*Edit Details Modal */}
            {showEditModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Specialities</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><FontAwesomeIcon icon={faTimes} /></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleEditSpecialitySubmit}>
                                    <div className="row form-row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Heading</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editSpecialityHeading}
                                                    onChange={(e) => setEditSpecialityHeading(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Image (Optional)</label>
                                                <input type="file" className="form-control" onChange={handleEditSpecialityFileChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-primary btn-block">Save Changes</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Modal */}
            {showDeleteModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="form-content p-2">
                                    <h4 className="modal-title">Delete</h4>
                                    <p className="mb-4">Are you sure want to delete?</p>
                                    <button type="button" className="btn btn-primary" onClick={confirmDelete}>Save </button>
                                    <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={handleCloseModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Tester;